module.exports = __webpack_public_path__ + "img/体育培训_1@2x.408ced06.png";